import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { saveToegangscontrole } from '../Reducers/actions';
import { renderField, renderselect, rendercheckbox } from '../../../../Components/Forms/renders';
import MultiSelectDagen from '../../../../Components/Forms/multiselect';
import { required, url } from 'redux-form-validators';
import Modal from "../../../../Components/Modal";

const ToegangscontroleForm = ({ 
  onClose, 
  provider,
  handleSubmit, 
  saveToegangscontrole,
  submitting 
}) => {
  const [visible, setVisible] = useState(true);
  const [loading, setLoading] = useState(false);
  const [authType, setAuthType] = useState('oauth2');

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 300); // Wait for animation
  };

  // Update auth type when it changes
  useEffect(() => {
    if (provider === 'doorcy' || provider === 'doorsy') {
      setAuthType('oauth2'); // Changed to oauth2 for Doorsy to support authcode flow
    } else {
      setAuthType('oauth2');
    }
  }, [provider]);

  const onSubmit = async (formValues) => {
    setLoading(true);

    const configData = {
      provider: provider || 'salto-ks',
      auth_type: authType,
      client_id: formValues.client_id,
      client_secret: formValues.client_secret,
      authorization_url: formValues.authorization_url,
      token_url: formValues.token_url,
      api_base_url: formValues.api_base_url,
      scopes: formValues.scopes ? formValues.scopes.split(',').map(s => s.trim()) : null,
      environment: formValues.environment,
      test_mode: formValues.test_mode !== undefined ? formValues.test_mode : true,
      webhook_url: formValues.webhook_url || '',
      beschrijving: formValues.beschrijving || '',
      auto_sync: formValues.auto_sync || false,
      sync_interval: parseInt(formValues.sync_interval) || 3600,
      actief: formValues.actief || false,
      // OAuth authorization code
      authorization_code: formValues.authorization_code || '',
      // Additional auth types
      api_key: formValues.api_key,
      bearer_token: formValues.bearer_token,
      username: formValues.username,
      password: formValues.password,
      // Doorcy/Doorsy specific configuration
      doorcy_id: formValues.doorcy_id || '',
      scene_ids: Array.isArray(formValues.scene_ids) ? formValues.scene_ids : [],
      // Webhook configuratie
      webhook_config: {
        url: formValues.webhook_url || '',
        label: formValues.webhook_label || '',
        enabled: formValues.webhook_enabled || false,
        events: formValues.webhook_events ? formValues.webhook_events.split(',').map(s => s.trim()) : ['reservation_created', 'reservation_updated', 'access_granted', 'access_denied']
      }
    };

    const result = await saveToegangscontrole(configData);
    
    if (result.success) {
      handleClose();
    }
    
    setLoading(false);
  };

  const environmentOptions = provider === 'doorcy' ? {
    production: 'Productie',
    development: 'Development (Test)'
  } : {
    sandbox: 'Sandbox (Test)',
    production: 'Productie'
  };

  return createPortal(
    <Modal visible={visible} onClose={handleClose} width={800}>
      <div className="card">
        <div className="card-header">
          <h4 className="mb-0">
            <i className={`fas ${(provider === 'doorcy' || provider === 'doorsy') ? 'fa-door-open' : 'fa-key'} me-2`}></i>
            {(provider === 'doorcy' || provider === 'doorsy') ? 'Doorsy API Configuratie' : 'Salto KS Configuratie'}
          </h4>
        </div>
        
        <form onSubmit={handleSubmit(onSubmit)} className="card-body">
          {loading && (
            <div className="overlay-loading">
              <div className="d-flex flex-column align-items-center">
                <i className="fas fa-spinner fa-spin fa-2x mb-2"></i>
                <p>Configuratie opslaan...</p>
              </div>
            </div>
          )}

          {/* General Settings */}
          <div className="row mb-4">
            <div className="col-12">
              <h5 className="border-bottom pb-2">
                <i className="fas fa-cog me-2"></i>
                Algemene Instellingen
              </h5>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <Field
                name="actief"
                component={rendercheckbox}
                type="checkbox"
                label="Toegangscontrole activeren"
                helpText="Schakel dit in om Salto KS integratie beschikbaar te maken"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <Field
                name="beschrijving"
                component={renderField}
                type="textarea"
                rows="3"
                label="Beschrijving"
                placeholder="Optionele beschrijving voor interne referentie"
              />
            </div>
          </div>

          {/* Authentication Configuration */}
          <div className="row mb-4 mt-4">
            <div className="col-12">
              <h5 className="border-bottom pb-2">
                <i className="fas fa-shield-alt me-2"></i>
                {authType === 'oauth2' ? 'OAuth/OpenID Connect Configuratie' : 
                 authType === 'api_key' ? 'API Key Authenticatie' : 
                 authType === 'bearer_token' ? 'Bearer Token Authenticatie' : 
                 'Basic Authentication'}
              </h5>
            </div>
          </div>

          {authType === 'oauth2' && (
            <>
              <div className="row">
                <div className="col-md-6">
                  <Field
                    name="client_id"
                    component={renderField}
                    type="text"
                    label="Client ID"
                    placeholder={(provider === 'doorcy' || provider === 'doorsy') ? 'Your Doorsy Client ID' : 'Your Salto KS Client ID'}
                    validate={[required({ msg: 'Client ID is verplicht' })]}
                    helpText={`Client ID uit je ${(provider === 'doorcy' || provider === 'doorsy') ? 'Doorsy' : 'Salto KS'} developer portal`}
                  />
                </div>
                <div className="col-md-6">
                  <Field
                    name="client_secret"
                    component={renderField}
                    type="password"
                    label="Client Secret"
                    placeholder={(provider === 'doorcy' || provider === 'doorsy') ? 'Your Doorsy Client Secret' : 'Your Salto KS Client Secret'}
                    validate={[required({ msg: 'Client Secret is verplicht' })]}
                    helpText={`Client Secret uit je ${(provider === 'doorcy' || provider === 'doorsy') ? 'Doorsy' : 'Salto KS'} developer portal`}
                  />
                </div>
              </div>

              {/* Authorization Code Field for OAuth2 */}
              <div className="row">
                <div className="col-12">
                  <Field
                    name="authorization_code"
                    component={renderField}
                    type="text"
                    label="Authorization Code (optioneel)"
                    placeholder="Plak hier de authorization code van Doorsy"
                    helpText="Krijg je authorization code door naar Doorsy te gaan en na autorisatie de code uit de URL te kopiëren"
                  />
                </div>
              </div>

            </>
          )}

          {authType === 'api_key' && (
            <div className="row">
              <div className="col-12">
                <Field
                  name="api_key"
                  component={renderField}
                  type="password"
                  label={provider === 'doorcy' ? 'API Token' : 'API Key'}
                  placeholder={provider === 'doorcy' ? 'Doorcy API Token' : 'Your API Key'}
                  validate={[required({ msg: provider === 'doorcy' ? 'API Token is verplicht' : 'API Key is verplicht' })]}
                  helpText={provider === 'doorcy' ? 'API Token uit je Doorcy admin panel' : `API Key uit je ${provider} dashboard`}
                />
              </div>
            </div>
          )}

          {authType === 'bearer_token' && (
            <div className="row">
              <div className="col-12">
                <Field
                  name="bearer_token"
                  component={renderField}
                  type="password"
                  label="Bearer Token"
                  placeholder="Your Bearer Token"
                  validate={[required({ msg: 'Bearer Token is verplicht' })]}
                  helpText="Bearer token voor API authenticatie"
                />
              </div>
            </div>
          )}

          {authType === 'basic_auth' && (
            <div className="row">
              <div className="col-md-6">
                <Field
                  name="username"
                  component={renderField}
                  type="text"
                  label="Username"
                  placeholder="Username"
                  validate={[required({ msg: 'Username is verplicht' })]}
                  helpText="Username voor Basic Authentication"
                />
              </div>
              <div className="col-md-6">
                <Field
                  name="password"
                  component={renderField}
                  type="password"
                  label="Password"
                  placeholder="Password"
                  validate={[required({ msg: 'Password is verplicht' })]}
                  helpText="Password voor Basic Authentication"
                />
              </div>
            </div>
          )}

          {/* API Endpoints */}
          <div className="row mb-4 mt-4">
            <div className="col-12">
              <h5 className="border-bottom pb-2">
                <i className="fas fa-globe me-2"></i>
                API Endpoints
              </h5>
            </div>
          </div>

          {authType === 'oauth2' && (
            <>
              <div className="row">
                <div className="col-md-6">
                  <Field
                    name="authorization_url"
                    component={renderField}
                    type="url"
                    label="Authorization URL"
                    placeholder="https://identity.my-clay.com/connect/authorize"
                    helpText="OAuth authorization endpoint"
                  />
                </div>
                <div className="col-md-6">
                  <Field
                    name="token_url"
                    component={renderField}
                    type="url"
                    label="Token URL"
                    placeholder="https://clp-accept-identityserver.my-clay.com/connect/token"
                    helpText="OAuth token endpoint"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Field
                    name="api_base_url"
                    component={renderField}
                    type="url"
                    label="API Base URL"
                    placeholder={(provider === 'doorcy' || provider === 'doorsy') ? 'https://test.api.doorcy.slcloud.nl' : 'https://api.saltoks.com'}
                    helpText={`Base URL voor ${(provider === 'doorcy' || provider === 'doorsy') ? 'Doorsy' : 'Salto KS'} API calls`}
                  />
                </div>
                <div className="col-md-6">
                  <Field
                    name="scopes"
                    component={renderField}
                    type="text"
                    label="OAuth Scopes"
                    placeholder="openid, profile, salto_api"
                    helpText="Comma-separated list van OAuth scopes"
                  />
                </div>
              </div>
            </>
          )}

          {authType !== 'oauth2' && (
            <div className="row">
              <div className="col-12">
                <Field
                  name="api_base_url"
                  component={renderField}
                  type="url"
                  label="API Base URL"
                  placeholder={provider === 'doorcy' ? 'https://api.doorcy.nl' : 'https://yourdomain.com/api'}
                  validate={[required({ msg: 'API Base URL is verplicht' }), url({ msg: 'Voer een geldige URL in' })]}
                  helpText={`Base URL voor ${provider === 'doorcy' ? 'Doorcy' : provider} API calls`}
                />
              </div>
            </div>
          )}

          {/* Environment Settings */}
          <div className="row mb-4 mt-4">
            <div className="col-12">
              <h5 className="border-bottom pb-2">
                <i className="fas fa-server me-2"></i>
                Environment Instellingen
              </h5>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Field
                name="environment"
                component={renderselect}
                options={environmentOptions}
                label="Environment"
                helpText="Selecteer sandbox voor testen, productie voor live gebruik"
              />
            </div>
            <div className="col-md-6">
              <Field
                name="test_mode"
                component={rendercheckbox}
                type="checkbox"
                label="Test modus"
                helpText="Schakel dit uit voor productie gebruik"
              />
            </div>
          </div>

          {/* Advanced Settings */}
          <div className="row mb-4 mt-4">
            <div className="col-12">
              <h5 className="border-bottom pb-2">
                <i className="fas fa-cogs me-2"></i>
                Geavanceerde Instellingen
              </h5>
            </div>
          </div>

          {/* Doorsy-specific configuration fields */}
          {(provider === 'doorcy' || provider === 'doorsy') && (
            <>
              <div className="row">
                <div className="col-md-6">
                  <Field
                    name="doorcy_id"
                    component={renderField}
                    type="text"
                    label="Doorcy ID"
                    placeholder="DOORCY-UUID-OF-ID"
                    helpText="Standaard Doorcy ID voor toegangscode generatie"
                  />
                </div>
                <div className="col-md-6">
                  <Field
                    name="scene_ids"
                    component={MultiSelectDagen}
                    label="Scene IDs"
                    options={[]}
                    allowCreate={true}
                    helpText="Voeg Scene IDs toe door te typen en Enter te drukken"
                  />
                </div>
              </div>

              {/* Webhook Configuratie */}
              <div className="row mb-4 mt-4">
                <div className="col-12">
                  <h5 className="border-bottom pb-2">
                    <i className="fas fa-webhook me-2"></i>
                    Webhook Configuratie
                  </h5>
                </div>
              </div>

              <div className="row">
                <div className="col-md-8">
                  <Field
                    name="webhook_url"
                    component={renderField}
                    type="url"
                    label="Webhook URL"
                    placeholder="https://enlqvmlw4n0to.x.pipedream.net"
                    helpText="URL waar webhooks naartoe verzonden worden"
                  />
                </div>
                <div className="col-md-4">
                  <Field
                    name="webhook_label"
                    component={renderField}
                    type="text"
                    label="Webhook Label"
                    placeholder="Test pipedream"
                    helpText="Beschrijvende naam voor de webhook"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Field
                    name="webhook_enabled"
                    component={rendercheckbox}
                    type="checkbox"
                    label="Webhook inschakelen"
                    helpText="Schakel in om webhooks te verzenden"
                  />
                </div>
                <div className="col-md-6">
                  <Field
                    name="webhook_events"
                    component={renderField}
                    type="text"
                    label="Webhook Events"
                    placeholder="reservation_created, reservation_updated, access_granted, access_denied"
                    helpText="Comma-separated list van events voor webhooks"
                  />
                </div>
              </div>
            </>
          )}

          <div className="row">
            <div className="col-md-6">
              <Field
                name="webhook_url"
                component={renderField}
                type="url"
                label="Webhook URL"
                placeholder={(provider === 'doorcy' || provider === 'doorsy') ? "https://yourdomain.com/webhooks/doorsy" : "https://yourdomain.com/webhooks/salto"}
                helpText={`URL voor ${(provider === 'doorcy' || provider === 'doorsy') ? 'Doorsy' : 'Salto KS'} webhooks (optioneel)`}
              />
            </div>
            <div className="col-md-6">
              <Field
                name="sync_interval"
                component={renderField}
                type="number"
                label="Sync Interval (seconden)"
                placeholder="3600"
                helpText="Interval voor automatische synchronisatie"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <Field
                name="auto_sync"
                component={rendercheckbox}
                type="checkbox"
                label="Automatische synchronisatie"
                helpText="Schakel in voor automatische data synchronisatie"
              />
            </div>
          </div>

          {/* Form Actions */}
          <div className="row mt-4">
            <div className="col-12">
              <div className="d-flex justify-content-end gap-2">
                <button 
                  type="button" 
                  className="btn btn-secondary"
                  onClick={handleClose}
                  disabled={loading}
                >
                  <i className="fas fa-times me-1"></i>
                  Annuleren
                </button>
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={loading || submitting}
                >
                  <i className="fas fa-save me-1"></i>
                  {loading ? 'Opslaan...' : 'Configuratie Opslaan'}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>,
    document.body
  );
};

// Initialize form with existing values - support multiple providers
const initializeForm = (existingConfig, provider) => {
  // Provider-specific defaults
  const getDefaults = (providerName) => {
    if (providerName === 'doorcy' || providerName === 'doorsy') {
      return {
        authorization_url: 'https://test.api.doorcy.slcloud.nl/oauth/authorize/',
        token_url: 'https://test.api.doorcy.slcloud.nl/oauth/token/',
        api_base_url: 'https://test.api.doorcy.slcloud.nl',
        scopes: 'read write',
        environment: 'development',
        auth_type: 'oauth2',
        test_mode: true,
        sync_interval: 3600,
      };
    }
    // Salto KS defaults
    return {
      authorization_url: 'https://identity.my-clay.com/connect/authorize',
      token_url: 'https://clp-accept-identityserver.my-clay.com/connect/token',
      api_base_url: 'https://api.saltoks.com',
      scopes: 'openid, profile, salto_api',
      environment: 'sandbox',
      auth_type: 'oauth2',
      test_mode: true,
      sync_interval: 3600
    };
  };

  const defaults = getDefaults(provider);

  if (!existingConfig) {
    return defaults;
  }

  const config = existingConfig.configuratie || {};
  const extraSettings = existingConfig.extra_instellingen || {};
  const oauthTokens = existingConfig.oauth_tokens || {};

  return {
    client_id: config.client_id || '',
    client_secret: config.client_secret || '',
    authorization_url: config.authorization_url || defaults.authorization_url,
    token_url: config.token_url || defaults.token_url,
    api_base_url: config.api_base_url || defaults.api_base_url,
    scopes: Array.isArray(config.scopes) ? config.scopes.join(', ') : (config.scopes || defaults.scopes),
    environment: config.environment || defaults.environment,
    test_mode: config.test_mode !== undefined ? config.test_mode : defaults.test_mode,
    auth_type: config.auth_type || defaults.auth_type,
    authorization_code: oauthTokens.authorization_code || '',
    api_key: config.api_key || '',
    bearer_token: config.bearer_token || '',
    username: config.username || '',
    password: config.password || '',
    webhook_url: extraSettings.webhook_url || '',
    beschrijving: extraSettings.beschrijving || '',
    auto_sync: extraSettings.auto_sync || false,
    sync_interval: extraSettings.sync_interval || defaults.sync_interval,
    actief: existingConfig.actief || false,
    // Doorcy/Doorsy specific configuration
    doorcy_id: config.doorcy_id || '',
    scene_ids: Array.isArray(config.scene_ids) ? config.scene_ids : [],
    // Webhook configuratie
    webhook_url: config.webhook_config?.url || '',
    webhook_label: config.webhook_config?.label || '',
    webhook_enabled: config.webhook_config?.enabled || false,
    webhook_events: Array.isArray(config.webhook_config?.events) ?
      config.webhook_config.events.join(', ') :
      'reservation_created, reservation_updated, access_granted, access_denied'
  };
};

const ToegangscontroleFormRedux = reduxForm({
  form: 'toegangscontroleForm',
  enableReinitialize: true
})(ToegangscontroleForm);

const mapStateToProps = (_, ownProps) => ({
  initialValues: initializeForm(ownProps.existingConfig, ownProps.provider)
});

export default connect(mapStateToProps, { saveToegangscontrole })(ToegangscontroleFormRedux);